import { useSnackbar } from '@kufox/mui/hooks';

export default function useToast() {
  const { message } = useSnackbar();
  return message;
}
